<div class="add-block-wrapper w-5rem">
  <i class="bi bi-plus-circle-fill add-block-button"></i>
  <!-- Duplicate dropdown menu -->
  <div *ngIf="selectedBlocks.length > 0" class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <div class="ui-grid-col-12">
        <!-- START: Additional dropdown menu for adding blocks -->
        <div class="hidden-dropdown">
          <p-select #dropdownBlocks [options]="blockSelect" optionLabel="dropdownName" optionValue="id"
                      [filter]="true" filterBy="dropdownName" [showClear]="true" placeholder="Select new block"
                      [style]="{ width: '100%', zIndex: '3' }" class="text-center" name="dropdownBlocks"
                      [disabled]="!isNew && lockedBy?.username !== currentUser?.username" resetFilterOnHide="true" scrollHeight="20rem">
            <ng-template let-block pTemplate="item">
              <div class="block-item-content" (click)="emitBlockSelect(block)">
                {{ block.dropdownName }}
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>
    </div>
    <!-- END: Additional dropdown menu for adding blocks -->
  </div>
</div>
